//this was migrated from the extensionsAPI wrapper. Eventually this can be discarded as well
import type {PS} from '@wix/document-services-types'

const refArray = {
    extractValues: (ps: PS, ...args: any[]) => ps.extensionAPI.data.refArray.extractValues(...args),
    extractValuesWithoutHash: (ps: PS, ...args: any[]) =>
        ps.extensionAPI.data.refArray.extractValuesWithoutHash(...args),
    create: (ps: PS, ...args: any[]) => ps.extensionAPI.data.refArray.create(...args),
    update: (ps: PS, ...args: any[]) => ps.extensionAPI.data.refArray.update(...args),
    isRefArray: (ps: PS, ...args: any[]) => ps.extensionAPI.data.refArray.isRefArray(...args)
}

const variantRelation = {
    extractVariants: (ps: PS, ...args: any[]) => ps.extensionAPI.data.variantRelation.extractVariants(...args),
    extractAllVariants: (ps: PS, ...args: any[]) => ps.extensionAPI.data.variantRelation.extractAllVariants(...args),
    extractTo: (ps: PS, ...args: any[]) => ps.extensionAPI.data.variantRelation.extractTo(...args),
    extractFrom: (ps: PS, ...args: any[]) => ps.extensionAPI.data.variantRelation.extractFrom(...args),
    create: (ps: PS, ...args: any[]) => ps.extensionAPI.data.variantRelation.create(...args),
    isVariantRelation: (ps: PS, ...args: any[]) => ps.extensionAPI.data.variantRelation.isVariantRelation(...args)
}

export default {
    refArray,
    variantRelation
}
